import api from "../api/axiosConfig";

const TTL_MS = 15 * 60 * 1000; 

let cacheProductos = null;
let cacheTimestamp = 0;
let cachePromise = null;

export const getProductosPublicos = async () => {
  const now = Date.now();

  if (
    cacheProductos &&
    now - cacheTimestamp < TTL_MS
  ) {
    return cacheProductos;
  }

  if (cachePromise) {
    return cachePromise;
  }

  cachePromise = api
    .get("/public/productos")
    .then((res) => {
      cacheProductos = res.data || [];
      cacheTimestamp = Date.now();
      return cacheProductos;
    })
    .finally(() => {
      cachePromise = null;
    });

  return cachePromise;
};

export const clearProductosCache = () => {
  cacheProductos = null;
  cacheTimestamp = 0;
  cachePromise = null;
};

export const isProductosCacheValid = () => {
  return (
    cacheProductos &&
    Date.now() - cacheTimestamp < TTL_MS
  );
};
